export default __webpack_public_path__ + "static/media/LATINA_PODCASTERS.dd828ddf.jpg";